<template>
  <article>
    <div v-if="title" class="chart-title">
      {{ title }}
    </div>
    <bar-chart
      :chart-data="chartData"
      :chart-options="mergedOptions"
      :plugins="threshold ? [thresholdPlugin] : []"
      style="min-height: 360px"
    />
  </article>
</template>

<script>
  import { Bar as BarChart } from 'vue-chartjs'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    LinearScale,
    CategoryScale,
  } from 'chart.js'

  ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale)

  export default {
    name: 'GroupedStackBarChart',
    components: { BarChart },
    props: {
      title: { type: String, default: null },
      labels: { type: Array, default: () => [] },
      datasets: { type: Array, default: () => [] },
      optionsOverride: { type: Object, default: () => ({}) },
      threshold: { type: Number, default: null },
    },
    data () {
      return {
        thresholdPlugin: {
          id: 'barThreshold',
          afterDraw: (chart) => {
            const t = this.threshold
            if (t === null || t === undefined) return
            const {
              ctx,
              chartArea: { left, right },
              scales: { y },
            } = chart
            const yPos = y.getPixelForValue(t)
            ctx.save()
            ctx.strokeStyle = '#EB5388'
            ctx.setLineDash([6, 4])
            ctx.beginPath()
            ctx.moveTo(left, yPos)
            ctx.lineTo(right, yPos)
            ctx.stroke()
            ctx.restore()
          },
        },
      }
    },
    computed: {
      chartData () {
        return { labels: this.labels, datasets: this.datasets }
      },
      mergedOptions () {
        const base = {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          scales: {
            x: { stacked: true, grid: { display: false } },
            y: { stacked: true, beginAtZero: true },
          },
          plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12 } },
            tooltip: { enabled: true },
          },
        }
        const override = this.optionsOverride
        if (!override.scales) {
          return { ...base, ...override }
        }
        return {
          ...base,
          ...override,
          scales: {
            x: { ...base.scales.x, ...(override.scales.x || {}) },
            y: { ...base.scales.y, ...(override.scales.y || {}) },
          },
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.chart-title {
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
